import { atom } from "jotai";
import {
  AudioRecordingState,
  ConsentStatus,
  ConsentUpdateSource,
} from "./constants";
import { DataChannelAppState, WritableDataChannelAtom } from "./types";
import { createDataChannelPropertyAtom } from "./utils";

const DEFAULT_LAST_UPDATED = 0;

export const DEFAULT_DATA_CHANNEL_APP_STATE = {
  provider: {
    consent: {
      value: ConsentStatus.UNKNOWN,
      lastUpdated: DEFAULT_LAST_UPDATED,
    },
  },
  patient: {
    consent: {
      value: ConsentStatus.UNKNOWN,
      lastUpdated: DEFAULT_LAST_UPDATED,
    },
    updateSource: {
      value: ConsentUpdateSource.UNKNOWN,
      lastUpdated: DEFAULT_LAST_UPDATED,
    },
  },
  isRecording: { value: false, lastUpdated: DEFAULT_LAST_UPDATED },
  isWhiteboardMode: { value: false, lastUpdated: DEFAULT_LAST_UPDATED },
  recordingState: {
    value: AudioRecordingState.NOT_RECORDING,
    lastUpdated: DEFAULT_LAST_UPDATED,
  },
};

export const dataChannelAppStateAtom = atom<DataChannelAppState>(
  DEFAULT_DATA_CHANNEL_APP_STATE,
);

// TODO: CARED-2179 Remove in favor of recordingStateAtom
export const isRecordingAtom: WritableDataChannelAtom<boolean> =
  createDataChannelPropertyAtom(dataChannelAppStateAtom, "isRecording");

export const recordingStateAtom: WritableDataChannelAtom<AudioRecordingState> =
  createDataChannelPropertyAtom(dataChannelAppStateAtom, "recordingState");
